import React from 'react';
import { View, ActivityIndicator } from 'react-native';
import { createStackNavigator } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';
import AdminLoginScreen from '../screens/AdminLoginScreen';
import AdminPanelScreen from '../screens/AdminPanelScreen';
import InspirationsManageScreen from '../screens/InspirationsManageScreen';
import InspirationAddScreen from '../screens/InspirationAddScreen';
import ParticipantsScreen from '../screens/ParticipantsScreen';
import ParticipantAddScreen from '../screens/ParticipantAddScreen';
import AdminHeader from '../components/layout/AdminHeader';
import { AdminProvider, useAdmin } from '../contexts/AdminContext';
import UserManagementScreen from '../screens/UserManagementScreen';
import AnalyticsDashboardScreen from '../screens/AnalyticsDashboardScreen';
import MentorManagementScreen from '../screens/MentorManagementScreen';
import FinancialManagementScreen from '../screens/FinancialManagementScreen';
import FeedbackManagementScreen from '../screens/FeedbackManagementScreen';
import EventsManageScreen from '../screens/EventsManageScreen';
import EventAddScreen from '../screens/EventAddScreen';
import GamificationManagementScreen from '../screens/GamificationManagementScreen';
import HoneyPotManagementScreen from '../screens/HoneyPotManagementScreen';
import HoneyPotAttemptsScreen from '../screens/HoneyPotAttemptsScreen';
import LMSProgressTrackingScreen from '../screens/LMSProgressTrackingScreen';
import ClustersScreen from '../screens/ClustersScreen';
import VersionManagementScreen from '../screens/VersionManagementScreen';

const Stack = createStackNavigator();

const AdminStackScreens = () => {
  const { isAuthenticated, loading } = useAdmin();

  if (loading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#f3f4f6' }}>
        <ActivityIndicator size="large" color="#6366F1" />
      </View>
    );
  }

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false
      }}
    >
      {!isAuthenticated ? (
        <Stack.Screen
          name="AdminLogin"
          component={AdminLoginScreen}
          options={{
            headerShown: false
          }}
        />
      ) : (
        <>
          <Stack.Screen
            name="AdminPanel"
            component={AdminPanelScreen}
          />
          <Stack.Screen
            name="Inspirations"
            component={InspirationsManageScreen}
          />
          <Stack.Screen
            name="InspirationAdd"
            component={InspirationAddScreen}
          />
          <Stack.Screen
            name="Participants"
            component={ParticipantsScreen}
          />
          <Stack.Screen
            name="ParticipantAdd"
            component={ParticipantAddScreen}
          />
          <Stack.Screen
            name="UserManagement"
            component={UserManagementScreen}
          />
          <Stack.Screen
            name="Analytics"
            component={AnalyticsDashboardScreen}
          />
          <Stack.Screen
            name="MentorManagement"
            component={MentorManagementScreen}
          />
          <Stack.Screen
            name="FinancialManagement"
            component={FinancialManagementScreen}
          />
          <Stack.Screen
            name="FeedbackManagement"
            component={FeedbackManagementScreen}
          />
          <Stack.Screen
            name="EventsManage"
            component={EventsManageScreen}
          />
          <Stack.Screen
            name="EventAdd"
            component={EventAddScreen}
          />
          <Stack.Screen
            name="Gamification"
            component={GamificationManagementScreen}
          />
          <Stack.Screen
            name="HoneyPot"
            component={HoneyPotManagementScreen}
          />
          <Stack.Screen
            name="HoneyPotAttempts"
            component={HoneyPotAttemptsScreen}
          />
          <Stack.Screen
            name="LMSProgressTracking"
            component={LMSProgressTrackingScreen}
          />
          <Stack.Screen
            name="Clusters"
            component={ClustersScreen}
          />
          <Stack.Screen
            name="VersionManagement"
            component={VersionManagementScreen}
          />
        </>
      )}
    </Stack.Navigator>
  );
};

const AdminStack = () => {
  return (
    <AdminProvider>
      <AdminStackScreens />
    </AdminProvider>
  );
};

export default AdminStack;
